import { logger } from "@/base/logger"
import { isNumberValid, isTruthyString } from "@/base/type-guards"

/**
 * Construct a date from a value.
 *
 * @param value - The value to construct a date from.
 *
 * @returns The date constructed from the value, or undefined if the value is not a valid date.
 */
export function constructDate(
  value: Date | number | string | null | undefined,
): Date | undefined {
  try {
    if (isNumberValid(value) || isTruthyString(value)) {
      return new Date(value)
    }
    if (value instanceof Date) {
      return value
    }
  } catch (error) {
    logger.error(
      "unable to construct date from value",
      value,
      typeof value,
      error,
    )
  }
  return undefined
}
